import "./Peo-Career.css";
import Footer from "./Footer";
import mailIcon from "../assets/mail-b.png";
import carCollage from "../assets/car.jpg";
import { useNavigate } from "react-router-dom";

export default function PeopleCareer() {
    const navigate = useNavigate();

    return (
        <section id="peo-car">
            <div className="careers-page">

                {/* TOP SECTION */}
                <div className="careers-top">

                    <div className="careers-text">
                        <h3>Careers</h3>

                        <h4>Building Leaders for Tomorrow</h4>

                        <p>
                            At Sundaram Clayton Limited (SCL), we believe careers grow
                            through meaningful work, continuous learning and strong values.
                            We provide opportunities to work on advanced technologies,
                            learn from global teams and build capabilities that prepare
                            you for long-term success.
                        </p>

                        <p>
                            Our people are encouraged to learn, innovate and take ownership
                            — supported by structured development programs and a culture
                            that values integrity, performance and collaboration.
                        </p>
                    </div>

                    {/* CAR COLLAGE */}
                    <div className="careers-image careers-collage">

                        <div className="career-collage-item career-img-one">
                            <img
                                src={carCollage}
                                alt="Careers at SCL"
                            />
                        </div>

                    </div>

                </div>

                {/* WHY JOIN SECTION */}
                <div className="why-join">

                    <h3>Why Join SCL</h3>

                    <div className="why-underline"></div>

                    <ul>
                        <li>
                            Exposure to state-of-the-art manufacturing and engineering
                            technologies
                        </li>

                        <li>
                            Structured technical and leadership development programs
                        </li>

                        <li>
                            Transparent, merit-based growth and succession planning
                        </li>

                        <li>
                            A supportive environment that encourages learning and innovation
                        </li>
                    </ul>

                </div>

                {/* APPLY SECTION */}
                <div className="apply-section">

                    <div className="apply-text">

                        <h3>Apply With Us</h3>

                        <p>
                            If you are passionate about building the future of mobility
                            with a purpose-driven organization, we would like to hear
                            from you.
                        </p>

                        <p className="email">

                            <img
                                src={mailIcon}
                                alt="mail"
                                style={{
                                    width: "18px",
                                    height: "14px",
                                    marginRight: "2px",
                                    verticalAlign: "middle"
                                }}
                            />

                            Email your resume to:

                            <a href="mailto:careers@scl.co.in">
                                careers@sundaramclayton.com
                            </a>

                            <br />

                            <span>
                                Please mention the position applied for in the subject line.
                            </span>

                        </p>

                        <button
                            className="contact-btn-p"
                            onClick={() => navigate("/contactus")}
                        >
                            Contact Us
                        </button>

                    </div>

                    {/* APPLY WITH US IMAGE */}
                    <div className="apply-image">
                        <img
                            src={require("../assets/car-Bottom.jpg")}
                            alt="Apply at SCL"
                        />
                    </div>

                </div>

            </div>

            <Footer />

        </section>
    );
}